import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React, { forwardRef } from 'react';
import styled, { css } from '@xstyled/styled-components';
import { th } from '@xstyled/system';
import { system } from '@trybeapp/ui.system';

var _excluded = ["content", "size", "title"];
var _templateObject, _templateObject2, _templateObject3;
var iconSvgStrokedStyles = /*#__PURE__*/css(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  g,\n  path {\n    stroke: inherit;\n    fill: none;\n  }\n"])));
var iconSvgFilledStyles = /*#__PURE__*/css(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  g,\n  path {\n    fill: currentColor;\n    stroke: none;\n  }\n"])));
var StyledIcon = /*#__PURE__*/styled.svg(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    stroked = _ref.stroked,
    width = _ref.width,
    height = _ref.height;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    ", ";\n    width: ", ";\n    height: ", ";\n    ", "\n  "])), stroked ? iconSvgStrokedStyles : iconSvgFilledStyles, width ? width + "px" : th("icons.sizes." + size), height ? height + "px" : th("icons.sizes." + size), system);
});
var Icon = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var content = _ref2.content,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'md' : _ref2$size,
    title = _ref2.title,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  if (!content) {
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    alt: title,
    dangerouslySetInnerHTML: {
      __html: content.block
    },
    ref: ref,
    role: "img",
    size: size,
    stroked: content.stroked,
    title: title,
    viewBox: content.viewBox || '0 0 100 100'
  }, props));
});

export { Icon, StyledIcon };
